module.exports = __webpack_public_path__ + "img/Bodice-Front-model up and bottom back width3300.2dbdc95f.png";